<template>
  <div class="container-fluid" style="overflow-y: hidden">
    <div class="row" style="margin-bottom: 5px">
      <div class="col">
        <b-button-group>
          <b-button
            style="font-size: 12px; padding: 5px"
            variant="link"
            @click="createItem()"
          >
            <svg
              width="24px"
              height="24px"
              fill="#699f4c"
              viewBox="0 0 60 60"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>{{ $store.state.localization.data.common.addLabel }}</title>
              <path
                d="M1080,270a30,30,0,1,1,30-30A30,30,0,0,1,1080,270Zm14-34h-10V226a4,4,0,0,0-8,0v10h-10a4,4,0,0,0,0,8h10v10a4,4,0,0,0,8,0V244h10A4,4,0,0,0,1094,236Z"
                id="add"
                transform="translate(-1050 -210)"
              />
            </svg>
          </b-button>
          <b-button
            style="font-size: 12px; padding: 5px"
            variant="link"
            :disabled="currentSelectedItem == null"
            @click="updateItem()"
          >
            <svg
              height="24px"
              width="24px"
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 512 512"
              xml:space="preserve"
            >
              <title>{{ $store.state.localization.data.common.updateLabel }}</title>
              <path
                style="fill: #dd539c"
                d="M505.842,130.44L443.7,68.299L381.559,6.158c-9.099-9.101-24.973-7.982-35.449,2.495L239.856,114.905
	l32.955,32.955l45.663,45.665l45.665,45.661l32.955,32.955L503.35,165.889C513.827,155.412,514.944,139.539,505.842,130.44z"
              />
              <path
                style="fill: #efc377"
                d="M85.444,426.555L6.828,347.934c-4.373,4.373-6.825,10.295-6.828,16.48l0.003,55.312v68.969
	c0,6.438,2.61,12.262,6.825,16.478c4.218,4.215,10.044,6.825,16.478,6.825h68.966l55.314,0.002c6.182,0,12.11-2.458,16.478-6.825
	L85.444,426.555z"
              />
              <polygon
                style="fill: #f4d944"
                points="364.141,239.189 318.475,193.525 272.812,147.863 239.858,114.905 6.828,347.934 
	85.444,426.555 164.064,505.175 397.094,272.141 "
              />
              <path
                style="fill: #ecb555"
                d="M0.003,488.693c0,6.439,2.61,12.262,6.825,16.478l78.617-78.617L6.828,347.934
	c-4.373,4.373-6.825,10.295-6.828,16.48l0.003,55.312V488.693z"
              />
              <polygon
                style="fill: #f1cc30"
                points="318.475,193.525 272.813,147.863 239.858,114.905 6.828,347.934 85.444,426.555 "
              />
              <path
                style="fill: #db348a"
                d="M318.475,193.525L443.7,68.299L381.559,6.158c-9.099-9.101-24.973-7.982-35.449,2.493
	L239.856,114.905l32.955,32.955L318.475,193.525z"
              />
            </svg>
          </b-button>
          <b-button
            style="font-size: 12px; padding: 5px"
            variant="link"
            :disabled="currentSelectedItem == null"
            @click="deleteItem()"
          >
            <svg
              height="24px"
              width="24px"
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 512 512"
              xml:space="preserve"
            >
              <title>{{ $store.state.localization.data.common.deleteLabel }}</title>
              <path
                style="fill: #ff6465"
                d="M256.002,503.671c136.785,0,247.671-110.886,247.671-247.672S392.786,8.329,256.002,8.329
	S8.33,119.215,8.33,256.001S119.216,503.671,256.002,503.671z"
              />
              <path
                style="opacity: 0.1; enable-background: new"
                d="M74.962,256.001c0-125.485,93.327-229.158,214.355-245.434
	c-10.899-1.466-22.016-2.238-33.316-2.238C119.216,8.329,8.33,119.215,8.33,256.001s110.886,247.672,247.671,247.672
	c11.3,0,22.417-0.772,33.316-2.238C168.289,485.159,74.962,381.486,74.962,256.001z"
              />
              <path
                style="fill: #ffffff"
                d="M311.525,256.001l65.206-65.206c4.74-4.74,4.74-12.425,0-17.163l-38.36-38.36
	c-4.74-4.74-12.425-4.74-17.164,0l-65.206,65.206l-65.206-65.206c-4.74-4.74-12.425-4.74-17.163,0l-38.36,38.36
	c-4.74,4.74-4.74,12.425,0,17.163l65.206,65.206l-65.206,65.206c-4.74,4.74-4.74,12.425,0,17.164l38.36,38.36
	c4.74,4.74,12.425,4.74,17.163,0l65.206-65.206l65.206,65.206c4.74,4.74,12.425,4.74,17.164,0l38.36-38.36
	c4.74-4.74,4.74-12.425,0-17.164L311.525,256.001z"
              />
              <path
                d="M388.614,182.213c0-5.467-2.129-10.607-5.995-14.471l-38.36-38.36c-3.865-3.865-9.004-5.994-14.471-5.994
	s-10.605,2.129-14.471,5.994l-59.316,59.316l-59.316-59.316c-3.865-3.865-9.004-5.994-14.471-5.994
	c-5.467,0-10.606,2.129-14.471,5.994l-38.36,38.36c-7.979,7.979-7.979,20.962,0,28.943l59.316,59.316l-59.316,59.316
	c-7.979,7.979-7.979,20.962,0,28.943l38.36,38.36c3.865,3.865,9.004,5.993,14.471,5.993c5.467,0,10.606-2.129,14.471-5.993
	l59.316-59.316l59.316,59.316c3.865,3.865,9.004,5.993,14.471,5.993s10.605-2.129,14.471-5.993l38.36-38.36
	c3.866-3.865,5.995-9.004,5.995-14.471c0-5.467-2.129-10.607-5.995-14.471l-59.315-59.316l59.315-59.315
	C386.485,192.818,388.614,187.68,388.614,182.213z M370.84,184.905l-65.204,65.206c-3.253,3.253-3.253,8.527,0,11.778l65.204,65.207
	c0.971,0.971,1.115,2.103,1.115,2.692c0,0.589-0.144,1.721-1.115,2.692l-38.36,38.36c-0.971,0.971-2.103,1.115-2.692,1.115
	c-0.589,0-1.722-0.144-2.692-1.115l-65.206-65.206c-1.626-1.626-3.758-2.44-5.889-2.44c-2.131,0-4.263,0.813-5.889,2.44
	l-65.206,65.206c-0.971,0.971-2.103,1.115-2.692,1.115c-0.59,0-1.722-0.144-2.693-1.115l-38.36-38.36
	c-1.484-1.485-1.484-3.9,0-5.385l65.206-65.206c3.253-3.253,3.253-8.527,0-11.778l-65.206-65.206c-1.484-1.485-1.484-3.9,0-5.385
	l38.359-38.36c0.971-0.971,2.104-1.115,2.693-1.115s1.722,0.144,2.692,1.115l65.206,65.206c3.253,3.253,8.527,3.253,11.778,0
	l65.206-65.206c0.971-0.971,2.103-1.115,2.692-1.115c0.589,0,1.722,0.144,2.692,1.115l38.36,38.36
	c0.971,0.971,1.115,2.103,1.115,2.692S371.811,183.934,370.84,184.905z"
              />
              <path
                d="M423.9,73.756c-3.229,3.276-3.191,8.55,0.086,11.778c46.016,45.349,71.358,105.89,71.358,170.466
	c0,63.931-24.896,124.035-70.102,169.241s-105.31,70.102-169.241,70.102c-35.385,0-69.471-7.555-101.311-22.455
	c-4.166-1.95-9.124-0.153-11.074,4.013c-1.95,4.166-0.153,9.124,4.013,11.074C181.695,503.917,218.156,512,255.999,512
	c68.381,0,132.668-26.629,181.019-74.982c48.352-48.352,74.98-112.64,74.98-181.019c0-69.072-27.106-133.825-76.323-182.331
	C432.401,70.44,427.128,70.478,423.9,73.756z"
              />
              <path
                d="M116.34,470.563c1.405,0.916,2.982,1.354,4.542,1.354c2.72,0,5.387-1.332,6.984-3.78c2.513-3.852,1.427-9.013-2.426-11.526
	c-68.115-44.424-108.78-119.419-108.78-200.611c0-63.931,24.896-124.035,70.102-169.24c45.206-45.206,105.31-70.102,169.241-70.102
	c52.234,0,101.864,16.528,143.525,47.796c3.679,2.761,8.9,2.017,11.66-1.662c2.761-3.679,2.017-8.9-1.662-11.661
	C364.958,17.681,311.87,0,256.002,0c-68.38,0-132.668,26.629-181.019,74.98C26.63,123.333,0.001,187.62,0.001,255.999
	C0.001,342.841,43.493,423.051,116.34,470.563z"
              />
            </svg>
          </b-button>
        </b-button-group>
      </div>
    </div>

    <div class="row" style="height:100%;">
      <div class="col-12" style="height:100%;">
        <b-table
          class="textMiddle"
          style="height: 100%;"
          small
          hover
          bordered
          show-empty
          responsive
          head-variant="light"
          selectable
          select-mode="single"
          :items="suppliers"
          :fields="headers"
          v-bind:emptyText="$store.state.localization.data.common.table.noData"
          @row-clicked="itemClicked"
          v-bind:sticky-header="clientHeight"
        >
          <template #cell(fuelDepo)="data">
            {{ formatFuelDepo(data.item.fuelDepoId) }}
          </template>
          <template v-slot:empty="scope">
            <div class="row justify-content-md-center">
              <h5>{{ scope.emptyText }}</h5>
            </div>
          </template>
          <template>
            <span class="text-success"></span>
          </template>
        </b-table>
      </div>
    </div>
    <CreateSupplierPage
        v-bind:fuelDepos="fuelDepos"
        v-bind:suppliers="suppliers"
        v-on:supplierCreatedSuccessEvent="supplierCreatedSuccessEvent"
        v-on:supplierCreatedFailEvent="supplierCreatedFailEvent"
        ref="create-item-page"
      ></CreateSupplierPage>
    <UpdateSupplierPage
        v-bind:supplier="currentSelectedItem"
        v-on:supplierUpdatedSuccessEvent="supplierUpdatedSuccessEvent"
        v-on:supplierUpdatedFailEvent="supplierUpdatedFailEvent"
        ref="update-item-page"
    ></UpdateSupplierPage>
  </div>
</template>

<script>
import CreateSupplierPage from "../CreateSupplier/CreateSupplierPage.vue";
import UpdateSupplierPage from "../UpdateSupplier/UpdateSupplierPage.vue";

import { azkService } from "../../../../services";

export default {
  name: "ListSuppliersPage",
  components: {
    CreateSupplierPage,
    UpdateSupplierPage,
  },
  props: {
    users: Array,
    suppliers: Array,
    fuelDepos: Array,
  },
  data() {
    return {
      currentSelectedItem: null
    };
  },
  computed: {
    headers() {
      const headers = [];

      for (let key in this.$store.state.localization.data.mainPage.azk.suppliers
          .tableColumns) {
            if (
              key == "id" ||
              key == "fuelDepo" ||
              key == "name" ||
              key == "responsiblePersonName" ||
              key == "responsiblePersonPhone"
            ) {
              headers.push({
                key: key,
                label:
                  this.$store.state.localization.data.mainPage.azk.suppliers.tableColumns[
                    key
                  ],
                sortable: true,
                thClass: "textMiddle",
              });
            }
        }

      return headers;
    },
    clientHeight() {
      const FUEL_TANKS_POSITION_Y = 140;

      return `${
        document.documentElement.clientHeight - FUEL_TANKS_POSITION_Y
      }px`;
    },
  },
  methods: {
    itemClicked(row) {
      this.currentSelectedItem = row;
    },
    createItem() {
      this.$refs["create-item-page"].open();
    },
    updateItem() {
      this.$refs["update-item-page"].open();
    },
    async deleteItem() {
      const isConfirm = confirm(
        this.$store.state.localization.data.common.entityDeleteConfirmation.replace("[ENTITY_NAME]", this.$store.state.localization.data.mainPage.azk.suppliers.pageLabel)
      );

      if (isConfirm) {
        const deleteItemResponse = await azkService.deleteEntity(this.currentSelectedItem.id, azkService.DELETED_ENTITY_SUPPLIER);

        if (
          deleteItemResponse.isSuccess &&
          deleteItemResponse.data &&
          deleteItemResponse.data.countInsertedRows == 1
        ) {
          this.currentSelectedItem = null;
          alert(this.$store.state.localization.data.common.entityDeleteSuccess.replace("[ENTITY_NAME]", this.$store.state.localization.data.mainPage.azk.suppliers.pageLabel));
          this.$emit("itemUpdatedEvent");
        } else {
          alert(this.$store.state.localization.data.common.entityDeleteError.replace("[ENTITY_NAME]", this.$store.state.localization.data.mainPage.azk.suppliers.pageLabel));
        }
      }
    },
    formatFuelDepo(fuelDepoId) {
      for (let i = 0; i < this.fuelDepos.length; i++) {
        if (
          this.fuelDepos[i].id == fuelDepoId
        ) {
          return this.fuelDepos[i].name;
        }
      }

      return "";
    },
    supplierCreatedSuccessEvent() {
      this.currentSelectedItem = null;
      alert(this.$store.state.localization.data.common.entityCreateSuccess.replace("[ENTITY_NAME]", this.$store.state.localization.data.mainPage.azk.suppliers.pageLabel));
      this.$emit("itemUpdatedEvent");
    },
    supplierCreatedFailEvent() {
      this.currentSelectedItem = null;
      alert(this.$store.state.localization.data.common.entityCreateError.replace("[ENTITY_NAME]", this.$store.state.localization.data.mainPage.azk.suppliers.pageLabel));
      this.$emit("itemUpdatedEvent");
    },
    supplierUpdatedSuccessEvent() {
      this.currentSelectedItem = null;
      alert(this.$store.state.localization.data.common.entityUpdateSuccess.replace("[ENTITY_NAME]", this.$store.state.localization.data.mainPage.azk.suppliers.pageLabel));
      this.$emit("itemUpdatedEvent");
    },
    supplierUpdatedFailEvent() {
      this.currentSelectedItem = null;
      alert(this.$store.state.localization.data.common.entityUpdateError.replace("[ENTITY_NAME]", this.$store.state.localization.data.mainPage.azk.suppliers.pageLabel));
      this.$emit("itemUpdatedEvent");
    },
  },
};
</script>
